/* eslint-disable max-len */
import styled from 'styled-components';
import { Select } from '../../ui';
import { Copy, Title } from '../dashboard/elements/LayoutElements';

export const OptionInfo = styled.div`
    display: inline-block;
    padding-right: 2rem;
    margin-right: 2rem;

    ${Title} {
        display: flex;
        align-items: center;
        gap: .5rem;
        margin-bottom: .5rem;
        font-size: 1rem;
    }
    ${Copy} {
        margin: 0;
        font-size: .875rem;
    }
`;

export const OptionControl = styled.div`
    display: inline-block;
    width: 10rem;
    display: flex;
    align-items: center;

    ${Select.Frame} {
        width: 100%;
    }
`;
